module.exports = __webpack_public_path__ + "img/jj2.bfd38083.png";